import { gql } from "@apollo/client"
// Define the mutation
export const CREATE_GEOFENCE_EVENT = gql`
    mutation CreateGeofenceEvent($record: CreateOneGeofenceEventInput!) {
        createGeofenceEvent(record: $record) {
            recordId
        }
    }
`
